import script from "./HiBakeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./HiBakeDetail.vue?vue&type=script&setup=true&lang=js"

import "./HiBakeDetail.vue?vue&type=style&index=0&id=98bfd7ca&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98bfd7ca"]])

export default __exports__